import { NATIONAL_CURRENCY } from '../constants';

const isInternationalPrice = ({
  currency = NATIONAL_CURRENCY
} = {}) => {
  return currency !== NATIONAL_CURRENCY;
};

export default isInternationalPrice;